import { render, staticRenderFns } from "./AccVerification.vue?vue&type=template&id=40258042&scoped=true&"
import script from "./AccVerification.vue?vue&type=script&lang=js&"
export * from "./AccVerification.vue?vue&type=script&lang=js&"
import style0 from "./AccVerification.vue?vue&type=style&index=0&id=40258042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40258042",
  null
  
)

export default component.exports